import TableRenderClass from '@C/tableRender/tableRenderClass';
import { invoice } from '@/api/ajax';
import { INVOICE_STATUS, MONEY_PLATFORM } from '@/api/searchTypes';
import { moneyFixed } from '@/tools/money';
import { makeTableRenderOptionsByMap } from '@/tools';

const PAY_STATUS = new Map([
  [0, '未支付'],
  [1, '支付中'],
  [2, '支付成功'],
  [3, '支付失败']
]);
const fields = {
  selection: {
    type: 'selection',
    width: '50px',
    prop: 'taxationId',
    reserve: true,
    selectable: row => {
      //payStatus 支付状态  0 未支付 1 支付中  2支付成功 3 支付失败
      // newPayStatus   0未支付”、1“支付中”、2“支付成功”  3“支付失败”、  4“线下支付完成  5“关闭支付”、
      if (
        +row.payStatus === 2 &&
        +row.invoiceStatus === 0 &&
        +row.newPayStatus !== 5
      ) {
        return true;
      }
    }
  },
  index: {
    width: '60px',
    label: '序号',
    type: 'index'
  },
  // taxationId: {
  //   label: '唯一',
  //   prop: 'taxationId'//  唯一
  // },
  fullName: {
    label: '项目参与人姓名',
    prop: 'fullName' //   项目参与人
  },
  userPhone: {
    label: '手机号',
    prop: 'userPhone' //  用户手机号
  },
  collectMoneyType: {
    label: '收款方式',
    prop: 'collectMoneyType', //  C端收款方式  1 银行卡  2 钱包
    formatter: (r, ctx, v) => {
      return MONEY_PLATFORM.get(+v);
    }
  },
  bfAccount: {
    label: '收款账号',
    prop: 'bfAccount' // 收款账号
  },
  projectPrice: {
    label: '终端结算金额',
    prop: 'projectPrice', //  终端结算金额
    formatter: (r, ctx, v) => moneyFixed(v)
  },
  invoiceStatus: {
    label: '开票状态',
    prop: 'invoiceStatus', //   0 未开票  1 已申请  2 已完成
    formatter: (r, ctx, v) => {
      return INVOICE_STATUS.get(v);
    }
  },
  payStatus: {
    label: '支付状态',
    prop: 'payStatus',
    formatter: (r, ctx, v) => PAY_STATUS.get(v)
  }
};
const search = [
  {
    width: 180,
    label: '项目参与人',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input',
    maxLength: 10,
    input: value => {
      return `${value}`.replace(/[^\u4E00-\u9FA5]/g, '');
    }
  },
  {
    width: 180,
    tip: '选择开票状态',
    key: 'invoiceStatus',
    id: 'xuanzekaipiaozhuangtai',
    slot: 'select',
    clearable: true,
    options: makeTableRenderOptionsByMap(INVOICE_STATUS, true)
  }
];
//初始化
export let example = new TableRenderClass({ search, fields });

/*主页面入口*/
export const main = [
  {
    name: '发票人员|列表',
    childMenu: [
      example.createPart({
        name: '发票人员|列表',
        search: ['fullName', 'xuanzekaipiaozhuangtai'],
        list: invoice.invoiceOpenListUserInfo,
        requestNow: true,
        defaultQuery: {},
        fields: [
          'selection',
          'taxationId',
          'index',
          'fullName',
          'userPhone',
          'collectMoneyType',
          'bfAccount',
          'projectPrice',
          'invoiceStatus'
          // 'payStatus'
        ],
        moreBtnArr: []
      })
    ]
  }
];
